import _ from "lodash";
import React from "react";
import classnames from "classnames"
import { useMessageManagementContext } from "../../../hooks/MessageManagementContext";
import { StandardTableSortableHeader } from "../../../components/tables/StandardTable";

export const PersonalMessagesVirtualTableColumns: { label: string, property: string }[] = [
    {
        label: "Sent Date",
        property: "sentOnDate"
    },
    {
        label: "Sender",
        property: "senderName"
    },
    {
        label: "Account",
        property: "masterAccountName"
    },
    {
        label: "Subject",
        property: "subject"
    },
    {
        label: "Status",
        property: "statusText"
    },
    {
        label: "Message",
        property: "message"
    },
    {
        label: "Priority",
        property: "messagePriority",
    },
    {
        label: "User Priority",
        property: "userPriority",
    },
    {
        label: "Deadline",
        property: "deadlineDate"
    },
    {
        label: "Remind On",
        property: "userReminderDate"
    },
    {
        label: "Done",
        property: "isDone"
    },
];

const PersonalMessageVirtualTableHeaderColumn = ({ label, property, className = null }: Readonly<{ label: string, property: string, className?: any | null }>) => {
    const { sort, sortTable } = useMessageManagementContext()!;
    const sortProperties = sort.split(',');
    const isHeaderSorted = _.some(sortProperties, (i: string[]) => i.includes(property));
    const headerDirection = isHeaderSorted && _.some(sortProperties, (i: string) => i.toLowerCase().includes('+desc')) ? "desc" : null;
    return (
        <StandardTableSortableHeader
            onClick={() => sortTable(property)}
            active={isHeaderSorted}
            direction={headerDirection}
            className={classnames(className)}
            isSticky={true}
        >
            {label}
        </StandardTableSortableHeader>
    )
};

const PersonalMessagesVirtualTableHeader = () => {
    return (
        <thead>
            <tr>
                {PersonalMessagesVirtualTableColumns.map((props, key) => <PersonalMessageVirtualTableHeaderColumn key={key} {...props} />)}
                <th className="sticky-header">&nbsp;</th>
            </tr>
        </thead>
    );
};

export default PersonalMessagesVirtualTableHeader;